import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Small } from 'foundations-components/transitional/components/Small';
import { Select } from 'foundations-components/transitional/components/Select';
import { Text } from 'foundations-components/components/Text';
import { WizardStep } from 'foundations-components/transitional/components/Wizard';
import { CUSTOMER_SUPPORT_LANGUAGES } from 'marketplace-ui-common/constants/Languages';
import { useEffect, useMemo, useState } from 'react';
import { LANGUAGE } from '../../../constants/search/FilterKey';
/* @ts-expect-error module is untyped */
import { translateFilterValue } from '../../../utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FindPartnerWizardLanguageStep({
  filters,
  onFilterChange
}) {
  const guessLang = getLang();
  const [guessed, setGuessed] = useState(null);
  useEffect(() => {
    if (!filters.language.length && guessed === null) {
      onFilterChange('language', [guessLang]);
      setGuessed(true);
    }
  }, [filters.language, guessLang, guessed, onFilterChange]);
  const options = useMemo(() => CUSTOMER_SUPPORT_LANGUAGES.map(lang => ({
    text: translateFilterValue(LANGUAGE, lang),
    value: lang
  })), []);
  return /*#__PURE__*/_jsxs(WizardStep, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      "data-test-id": "findPartnerWizard-step-4",
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.language.title"
      })
    }), /*#__PURE__*/_jsx(Select, {
      anchorType: "combined",
      multi: true,
      onChange: ({
        target: {
          value
        }
      }) => {
        onFilterChange('language', value);
        setGuessed(false);
      },
      options: options,
      value: filters.language
    }), guessed && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    })]
  });
}